export const physician: { [key: string]: string[] } = {
  "Primary Care": [
    "207R00000X",
    "207RA0401X",
    "207RA0000X",
    "207RA0002X",
    "207RA0001X",
    "207RA0201X",
    "207RC0000X",
    "207RI0001X",
    "207RC0001X",
    "207RC0200X",
    "207RE0101X",
    "207RG0100X",
    "207RG0300X",
    "207RH0000X",
    "207RH0003X",
    "207RI0008X",
    "207RH0002X",
    "207RH0005X",
    "207RI0200X",
    "207RI0011X",
    "207RM1200X",
    "207RX0202X",
    "207RN0300X",
    "207RB0002X",
    "207RP1001X",
    "207RR0500X",
    "207RS0012X",
    "207RS0010X",
    "207RT0003X",
    "207Q00000X",
    "207QA0401X",
    "207QA0000X",
    "207QA0505X",
    "207QG0300X",
    "207QH0002X",
    "207QB0002X",
    "207QS1201X",
    "207QS0010X",
    "208D00000X",
    "208000000X",
    "2080A0000X",
    "2080C0008X",
    "2080I0007X",
    "2080P0006X",
    "2080H0002X",
    "2080T0002X",
    "2080N0001X",
    "2080P0008X",
    "2080B0002X",
    "2080P0201X",
    "2080P0202X",
    "2080P0203X",
    "2080P0204X",
    "2080P0205X",
    "2080P0206X",
    "2080P0207X",
    "2080P0208X",
    "2080P0210X",
    "2080P0214X",
    "2080P0216X",
    "2080T0004X",
    "2080S0012X",
    "2080S0010X",
    "207V00000X",
    "207VC0300X",
    "207VC0200X",
    "207VF0040X",
    "207VX0201X",
    "207VG0400X",
    "207VH0002X",
    "207VM0101X",
    "207VB0002X",
    "207VX0000X",
    "207VE0102X",
    "2251G0304X",
  ],

  "Specialty Care": [
    "2084A0401X",
    "2084P0802X",
    "2084B0040X",
    "2084P0301X",
    "2084P0804X",
    "2084N0600X",
    "2084D0003X",
    "2084E0001X",
    "2084F0202X",
    "2084P0805X",
    "2084H0002X",
    "2084A2900X",
    "2084P0005X",
    "2084N0400X",
    "2084N0402X",
    "2084N0008X",
    "2084B0002X",
    "2084P2900X",
    "2084P0800X",
    "2084P0015X",
    "2084S0012X",
    "2084S0010X",
    "2084V0102X",
    "208C00000X",
    "207T00000X",
    "204E00000X",
    "207X00000X",
    "207XS0114X",
    "207XX0004X",
    "207XS0106X",
    "207XS0117X",
    "207XX0801X",
    "207XP3100X",
    "207XX0005X",
    "208200000X",
    "2082S0099X",
    "2082S0105X",
    "208600000X",
    "2086H0002X",
    "2086S0120X",
    "2086S0122X",
    "2086S0105X",
    "2086S0102X",
    "2086X0206X",
    "2086S0127X",
    "2086S0129X",
    "208G00000X",
    "204F00000X",
    "207ND0101X",
    "207VF0040X",
    "207WX0200X",
    "207XS0114X",
    "207XX0004X",
    "207XS0106X",
    "207XS0117X",
    "207XP3100X",
    "207YS0123X",
    "207YX0905X",
    "207YX0007X",
    "2082S0099X",
    "2082S0105X",
    "2086S0120X",
    "2086S0122X",
    "2086S0105X",
    "2086S0127X",
    "2086S0129X",
    "2088F0040X",
    "1223S0112X",
    "207L00000X",
    "207LA0401X",
    "207LC0200X",
    "207LH0002X",
    "207LP2900X",
    "207LP3000X",
    "207P00000X",
    "207PE0004X",
    "207PH0002X",
    "207PT0002X",
    "207PP0204X",
    "207PS0010X",
    "207PE0005X",
    "2085B0100X",
    "2085D0003X",
    "2085R0202X",
    "2085U0001X",
    "2085H0002X",
    "2085N0700X",
    "2085N0904X",
    "2085P0229X",
    "2085R0001X",
    "2085R0205X",
    "2085R0203X",
    "2085R0204X",
    "207RA0001X",
    "207RI0011X",
    "207UN0901X",
    "2080P0202X",
    "207RH0003X",
    "207RX0202X",
    "207VX0201X",
    "2080P0207X",
    "2085R0001X",
    "2086X0206X",
    "207RE0101X",
    "207VE0102X",
    "2080P0205X",
    "207SG0207X",
    "207U00000X",
  ],
};

export const common_skills: { [key : string] : string[] } = {
  "Hypertension (high blood pressure)": [
    "207RH0005X",
    "2080P0210X",
    "207RA0002X",
  ],
  Asthma: ["207RP1001X", "207K00000X", "2080P0214X"],
  Diabetes: ["207RE0101X", "2080P0205X", "163WD0400X"],
  Cardiology: [
    "207U00000X",
    "208G00000X",
    "207RA0001X",
    "207RI0011X",
    "207UN0901X",
    "2080P0202X",
    "1835C0206X",
  ],
  Depression: ["2084P0800X", "2084P0015X", "2084B0040X", "103TC0700X"],
  Arthritis: [
    "207RR0500X",
    "2080P0216X",
    "207XX0004X",
    "207XS0106X",
    "207XS0117X",
  ],
  "COPD (Chronic obstructive pulmonary disease)": [
    "208100000X",
    "207RC0200X",
    "207P00000X",
    "207RP1001X",
  ],
  Osteoporosis: ["207RR0500X", "207RE0101X", "207X00000X"],
  Migraine: ["207LP2900X", "207R00000X"],
  Cancer: [
    "207RH0003X",
    "207RX0202X",
    "207VX0201X",
    "2080P0207X",
    "2085R0001X",
    "2086X0206X",
    "133VN1301X",
    "163WX0200X",
    "163WP0218X",
    "1835X0200X",
    "364SX0200X",
    "364SX0204X",
    "261QX0200X",
    "261QX0203X",
  ],
};

export const organization_types: { [key : string] : string[] } = {
  "Private Health Plans" : [
    "United Health Care", 
    "Cigna"
  ], 
  "Public Health Plans" : [
    "La Care"
  ]
}